import {Environment} from './environment';

export const publicProtocolByEnvironment: Record<
  Environment,
  'http' | 'https'
> = {
  production: 'https',
  preview: 'https',
  staging: 'https',
  development: 'http',
};
